import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import styled from 'styled-components';

import TablePaginationActions from './TablePaginationActions';

const StyledTablePagination = styled(TablePagination)`
  display: flex;
  overflow-y: hidden;
  max-width: 100% !important;
  min-height: 60px;
  background-color: #f5f5f5;
  .MuiTablePagination-toolbar {
    margin-left: auto;
  }
`;

const CustomTablePagination = ({
  pageSizeOptions,
  pageSize,
  pageIndex,
  gotoPage,
  setPageSize,
  setMinHeight,
  rows,
}) => (
  <StyledTablePagination
    rowsPerPageOptions={pageSizeOptions}
    component="div"
    colSpan={3}
    count={rows.length}
    rowsPerPage={pageSize}
    page={pageIndex}
    SelectProps={{
      inputProps: { 'aria-label': 'rows per page' },
      native: true,
    }}
    onPageChange={(event, newPage) => {
      gotoPage(newPage);
    }}
    onRowsPerPageChange={(event) => {
      setPageSize(Number(event.target.value));
      setMinHeight(0);
    }}
    ActionsComponent={TablePaginationActions}
  />
);

export default CustomTablePagination;
